module.exports = __webpack_public_path__ + "iPhone11-Purple@2x.png?1bafe3b6acde63fef7025c50a8df8bc9";